import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../../components/NtText";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import { useTheme } from "../../../context/ThemeContext";
import { onboardingSteps } from "../../data/onboardingSteps";

function NtOnboardingWelcomeStep() {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  // Skip the welcome step itself when listing what's coming up.
  const upcoming = onboardingSteps.slice(1);

  return (
    <View>
      <NtText style={styles.sectionLabel}>What you'll set up</NtText>
      <View style={styles.list}>
        {upcoming.map((step, index) => (
          <View key={step.key} style={styles.row}>
            <View style={styles.num}>
              <NtText style={styles.numText}>{index + 1}</NtText>
            </View>
            <View style={styles.rowMid}>
              <NtText style={styles.rowTitle}>{step.title}</NtText>
            </View>
            <NtMaterialIcon name={step.icon} size={18} color={theme.textDim} />
          </View>
        ))}
      </View>
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    sectionLabel: {
      fontSize: 11,
      fontWeight: "700",
      color: t.textMute,
      textTransform: "uppercase",
      letterSpacing: 0.6,
      marginBottom: 14,
    },
    list: {
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.border,
      borderRadius: t.radiusCard,
      overflow: "hidden",
    },
    row: {
      flexDirection: "row",
      alignItems: "center",
      gap: 14,
      paddingVertical: 14,
      paddingHorizontal: 18,
      borderBottomWidth: 1,
      borderBottomColor: t.borderSoft,
    },
    num: {
      width: 28,
      height: 28,
      borderRadius: 14,
      backgroundColor: t.pillBg,
      borderWidth: 1,
      borderColor: t.pillBorder,
      alignItems: "center",
      justifyContent: "center",
    },
    numText: { fontSize: 12, fontWeight: "700", color: t.brand2 },
    rowMid: { flex: 1 },
    rowTitle: { fontSize: 14, color: t.text, fontWeight: "600" },
  });

export default NtOnboardingWelcomeStep;
